import { createContext } from 'react';
import type { StreamChat } from 'stream-chat';

interface ChatContextType {
  chatUserId: null | string;
  client: null | StreamChat;
  error: Error | null;
  unread: number;
}
export const ChatContext = createContext<ChatContextType | null>(null);
